import { CapaQuotationDetailedServiceType } from '@generated/graphql';
import Assets from '../Assets';
export default [
  {
    id: 1,
    name: '밀링',
    src: Assets.CNC.MillingImage,
    serviceEnum: CapaQuotationDetailedServiceType.Milling,
    url:
      'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0'
  },
  {
    id: 2,
    name: '선반',
    src: Assets.CNC.LatheImage,
    serviceEnum: CapaQuotationDetailedServiceType.Turning,
    url:
    'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0'
  },
  {
    id: 3,
    name: '머시닝 센터',
    src: Assets.CNC.MachiningImage,
    serviceEnum: CapaQuotationDetailedServiceType.MachiningCenter,
    url:
    'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0'
  },
  {
    id: 4,
    name: '드릴링',
    src: Assets.CNC.DrillingImage,
    serviceEnum: CapaQuotationDetailedServiceType.Drilling,
    url:
    'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0'
  },
  {
    id: 5,
    name: '추천이 필요합니다.',
    src: Assets.CNC.RecommendCNC,
    serviceEnum: CapaQuotationDetailedServiceType.Recommend,
    url:
    'https://capa.ai/blog/posts/cnc-%EA%B0%80%EA%B3%B5-%EC%B4%9D%EC%A0%95%EB%A6%AC-%EA%B3%B5%EC%9E%91-%EA%B8%B0%EA%B3%84%EB%A5%BC-%ED%86%B5%ED%95%9C-%EC%A0%9C%ED%92%88-%EC%83%9D%EC%82%B0'
  }
];
